import { updateItemInCollection } from "directus/src/operations";

// Add createProject function
export async function updateProject({ item, projectId }) {
  try {
    const query = {
      fields: [
        "id",
        "logo",
        "name",
        "project_id",
        "client",
        "sales_coordinator",
        "coordinator",
        "account_manager",
        "legal_entity",
        "description",
      ],
    };

    const data = await updateItemInCollection(
      "projects",
      projectId,
      item,
      query
    );

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
